import React from 'react'

//TODO: This will need to have a list of cards with the pets for the logged in user
//TODO: This will only be visible if the user is logged in

function Sidebar() {
    return (
        <div className='sidebar'>
            <h3>Left sidebar</h3>
        </div>
    )
}

export default Sidebar